import actionTypes from 'dashboard/actions/big-winners/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_BIG_WINNERS_HISTORY_SUCCESS:
      return [...action.items];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/big-winners/items.js